const setPrivacyPolicy = payload => ({
  type: "SET_PRIVACY_POLICY",
  payload
});

export default {
  setPrivacyPolicy
};
